module.exports = __webpack_public_path__ + "img/logo3.ca9ec82a.png";